import $ from 'jquery'
import ChartDateRangeSectionStrategy from './ChartDateRangeSectionStrategy'

function SingleDateChartDateRangeSectionStrategy() {}

SingleDateChartDateRangeSectionStrategy.prototype = new ChartDateRangeSectionStrategy();

SingleDateChartDateRangeSectionStrategy.prototype.updateSectionUI = function()
{
    ChartDateRangeSectionStrategy.prototype.updateSectionUI.call( this );
    $( this.container ).addClass( "withSingleDateSelector" );
};

SingleDateChartDateRangeSectionStrategy.prototype.getSelectedParamsJSON = function()
{
    return { dateSelection: this.singleDateSelector.getSelectedRangeJSON() };
};

SingleDateChartDateRangeSectionStrategy.prototype.getSelectedParams = function()
{
    return { dateSelection: this.singleDateSelector.getSelectedRange() };
};

export default SingleDateChartDateRangeSectionStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/SingleDateChartDateRangeSectionStrategy.js